import React from 'react'
import { Col, List, Row, Typography } from 'antd'
import CustomList from '../../../components/Shared/CustomList'
import CustomVideo from '../../../components/Shared/CustomVideo'
import { GeneralTitle } from '../../../components/Shared'

const { Title, Paragraph } = Typography

const services = [
	'Databases',
	'Web Programming',
	'WordPress / E-commerce',
	'Data Analysis',
	'Mobile Apps',
	'API'
]

const ProgrammingAndTech = () => {
	return (
		<>
			<GeneralTitle>Programming & Tech</GeneralTitle>

			<Row gutter={[20, 20]} justify="space-between" align="middle">
				<Col xs={24} sm={24} md={14} lg={14}>
					<Title level={4}>
						Get all the technical bells and whistles
					</Title>
					<Paragraph>
						Webackit Solutions SRL is a software company with over
						11 years of experience in providing reliable software
						solutions to businesses from a broad range of
						industries.
					</Paragraph>
					<Paragraph>
						We cover WordPress, mobile apps (Android, iOS, using
						EXPO and React Native), Python automation, Crypto
						Analysis and statistics, and custom web solutions.
					</Paragraph>
					<Title level={5}>
						Best practices make a great software
					</Title>
					<Paragraph>
						Our capacity to help customers results from implementing
						particular processes in software development. We are
						also open to using a specific methodology based on the
						project's requirements.
					</Paragraph>
					<Title level={5}>We understand your business</Title>
					<Paragraph>
						We ask all the right questions from the beginning of our
						collaboration to validate assumptions and create a clear
						roadmap towards achieving the required business goals.
					</Paragraph>
					<CustomList
						dataSource={services}
						renderItem={(item) => <List.Item>{item}</List.Item>}
					/>
				</Col>
				<Col xs={24} sm={24} md={10} lg={10}>
					<img
						width="100%"
						src={`${process.env.PUBLIC_URL}/branding/webackit-services-diagram-tech-programming.svg`}
						alt="WordPress Services Diagram"
					/>
				</Col>
			</Row>

			<CustomVideo
				src="https://webackit.com/videos/webackit-exceeding-expectations.mp4"
				type="video/mp4"
				styleProps={{
					width: '100%'
				}}
			/>
		</>
	)
}

export default ProgrammingAndTech
